var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10h-1v-2c0-2.205-1.794-4-4-4s-4 1.795-4 4v2h-1c-1.103 0-2 0.896-2 2v7c0 1.104 0.897 2 2 2h10c1.103 0 2-0.896 2-2v-7c0-1.104-0.897-2-2-2zM12 18.299c-0.719 0-1.3-0.58-1.3-1.299s0.581-1.301 1.3-1.301 1.3 0.582 1.3 1.301-0.581 1.299-1.3 1.299zM14 11h-4v-3c0-1.104 0.897-2 2-2s2 0.896 2 2v3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.9c99c54e3c9c52b35abd5e107bb085a9.svg";
export { ForwardRef as ReactComponent };